import Menu from "./Menu";
import ClassTable from "./ClassTable";

const ClassPage = () => {
  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-3 lg:space-y-0">
        <div className="w-full lg:flex-1">
          <Menu />
        </div>
      </div>
      <ClassTable />
    </section>
  );
};

export default ClassPage;
